import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations('jStoreExperienceManagerV2', [
      'setIsBulk', 'setIsSearch', 'setIsDataSet', 'setIsComponent', 'setIsFieldGroup', 'setShowModalFieldLibrary', 'setPropertiesOpened',
      'setIsTableGroup', 'setIsDataPreview', 'setIsDataPreviewGroup', 'setIsShowModalFieldFromGroup', 'setSourceModalFieldLibrary',
      'setCustomField',
    ]),

    resetBeforeDestroy() {
      this.setIsBulk(false);
      this.setIsSearch(false);
      this.setIsDataSet(false);
      this.setIsComponent(false);
      this.setIsFieldGroup(false);
      this.setIsTableGroup(false);
      this.setIsDataPreview(false);
      this.setPropertiesOpened(false);
      this.setIsDataPreviewGroup(false);
      this.setShowModalFieldLibrary(false);
      this.setSourceModalFieldLibrary(false);
      this.setIsShowModalFieldFromGroup(false);
      this.setCustomField(null);
    },
  },

  beforeDestroy() {
    this.resetBeforeDestroy();
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixToolbox.js